<div class="daisy-card bg-base-100 border border-base-300 shadow-md hover:shadow-lg transition-shadow duration-300 relative">
  @if (isDefault){
  <div class="absolute top-0 right-0 m-3">
    <div class="daisy-badge daisy-badge-primary gap-1">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      Default
    </div>
  </div>
  }

  <div class="daisy-card-body">
    <div class="flex items-start gap-4">
      <div class="daisy-avatar daisy-placeholder">
        <div class="bg-primary/10 text-primary rounded-lg w-12 h-12 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
        </div>
      </div>
      <div class="flex-1">
        <h3 class="daisy-card-title text-lg">{{ provider | titlecase }}</h3>
        <p class="text-sm text-base-content/70 mt-1">{{ accountUsername }}</p>
        <div class="flex items-center gap-2 mt-2">
          <span class="text-xs text-base-content/60">Status:</span>
          <span class="daisy-badge daisy-badge-success daisy-badge-sm">{{ status }}</span>
        </div>
      </div>
    </div>
    
    <div class="daisy-card-actions justify-end mt-4 pt-4 border-t border-base-300">
      <button 
        (click)="unlinkAccount()" 
        class="daisy-btn daisy-btn-sm daisy-btn-error daisy-btn-outline gap-2"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
        </svg>
        Unlink Account
      </button>
    </div>
  </div>
</div>
